var map = {
	"./constitutiva/estatus/1.webp": "./src/assets/img/constitutiva/estatus/1.webp",
	"./constitutiva/estatus/2.webp": "./src/assets/img/constitutiva/estatus/2.webp",
	"./constitutiva/estatus/3.webp": "./src/assets/img/constitutiva/estatus/3.webp",
	"./constitutiva/estatus/4.webp": "./src/assets/img/constitutiva/estatus/4.webp",
	"./constitutiva/estatus/5.webp": "./src/assets/img/constitutiva/estatus/5.webp",
	"./constitutiva/estatus/6.webp": "./src/assets/img/constitutiva/estatus/6.webp",
	"./constitutiva/estatus/7.webp": "./src/assets/img/constitutiva/estatus/7.webp",
	"./cotejos/estatus/1.webp": "./src/assets/img/cotejos/estatus/1.webp",
	"./cotejos/estatus/2.webp": "./src/assets/img/cotejos/estatus/2.webp",
	"./cotejos/estatus/3.webp": "./src/assets/img/cotejos/estatus/3.webp",
	"./cotejos/estatus/4.webp": "./src/assets/img/cotejos/estatus/4.webp",
	"./cotejos/estatus/5.webp": "./src/assets/img/cotejos/estatus/5.webp",
	"./cotejos/estatus/6.webp": "./src/assets/img/cotejos/estatus/6.webp",
	"./cotejos/estatus/7.webp": "./src/assets/img/cotejos/estatus/7.webp",
	"./formalizaciones/estatus/1.webp": "./src/assets/img/formalizaciones/estatus/1.webp",
	"./formalizaciones/estatus/2.webp": "./src/assets/img/formalizaciones/estatus/2.webp",
	"./formalizaciones/estatus/3.webp": "./src/assets/img/formalizaciones/estatus/3.webp",
	"./formalizaciones/estatus/4.webp": "./src/assets/img/formalizaciones/estatus/4.webp",
	"./formalizaciones/estatus/5.webp": "./src/assets/img/formalizaciones/estatus/5.webp",
	"./formalizaciones/estatus/6.webp": "./src/assets/img/formalizaciones/estatus/6.webp",
	"./formalizaciones/estatus/7.webp": "./src/assets/img/formalizaciones/estatus/7.webp",
	"./formalizaciones/estatus/8.webp": "./src/assets/img/formalizaciones/estatus/8.webp",
	"./notificaciones/estatus/1.webp": "./src/assets/img/notificaciones/estatus/1.webp",
	"./notificaciones/estatus/2.webp": "./src/assets/img/notificaciones/estatus/2.webp",
	"./notificaciones/estatus/3.webp": "./src/assets/img/notificaciones/estatus/3.webp",
	"./notificaciones/estatus/4.webp": "./src/assets/img/notificaciones/estatus/4.webp",
	"./notificaciones/estatus/5.webp": "./src/assets/img/notificaciones/estatus/5.webp",
	"./notificaciones/estatus/6.webp": "./src/assets/img/notificaciones/estatus/6.webp",
	"./notificaciones/estatus/7.webp": "./src/assets/img/notificaciones/estatus/7.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*\\/estatus\\/.*\\.webp$";